import React, { useState } from "react";
import { MdClear, MdEdit, MdRemoveRedEye } from "react-icons/md";
import AddPreloadedClause from "../../modals/policy/AddPreloadedClause";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BiArrowBack } from "react-icons/bi";
import ModalContainer from "../../modals/ModalContainer";
import ConfirmUnderwrite from "../../modals/policy/ConfirmUnderwrite";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import {
  addClauses,
  deleteClause,
  resetClauses,
  resetUnderwritingStatus,
  submitUnderwriting,
} from "../../../redux/slice/underwriting/underwritingSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { forwardRef } from "react";

const PreloadedClauses = forwardRef(
  ({ setUnderWritten, underWritten }, ref) => {
    const { clauses, isUpdated, isLoading } = useSelector(
      (state) => state?.underwriting
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [draggedClauses, setDraggedClauses] = useState(clauses);
    const [preloadedClauses, setPreloadedClauses] = useState(null);
    const [editData, setEditData] = useState(null);

    // Function to handle the drag and rearrange
    const handleOnDragEnd = (result) => {
      if (!result.destination) return; // Item was dropped outside the list

      const items = Array.from(draggedClauses);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setDraggedClauses(items);
    };

    const handleSubmit = async () => {
      let payload = { ...underWritten, customer_clauses: clauses };
      dispatch(submitUnderwriting(payload));
    };

    useEffect(() => {
      if (clauses) {
        let sortedClauses = clauses.map((item) => ({
          ...item,
          clause_id: item.clause_id.toString(),
        }));
        setDraggedClauses(sortedClauses);
      }
    }, [clauses]);

    useEffect(() => {
      if (isUpdated) {
        dispatch(resetUnderwritingStatus());
        navigate("/admin/customer-policy-view/policy-schedule");
      }
    }, [isUpdated]);

    return (
      <div>
        <div className='row'>
          <div className='col-lg- col-md-6'>
            <span
              className='btn btn-primary text-white px-4 text-center'
              data-bs-toggle='modal'
              data-bs-target='#add_clause'
              onClick={() => setPreloadedClauses}
            >
              <span>Add Preloaded Clause</span>
            </span>
          </div>
        </div>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId='droppable'>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className='mt-3 col-lg-5 col-md-10'
              >
                {draggedClauses?.map((item, i) => (
                  <Draggable
                    key={item.clause_id + i}
                    draggableId={item.clause_id}
                    index={i}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        key={item.clause_id}
                        className='d-flex justify-content-between align-items-center py-1 px-1 shadow-hover'
                      >
                        <div className='d-flex align-items-center gap-1'>
                          <span>{i + 1}.</span>
                          <span>{item.clause_name}</span>
                        </div>
                        <div className='d-flex align-items-center gap-2'>
                          <span
                            data-bs-toggle='modal'
                            data-bs-target='#add_clause'
                            className='cursor-p'
                            onClick={() => setEditData(item)}
                          >
                            <MdEdit />
                          </span>
                          {/* <span>
                          <MdRemoveRedEye className='text-primary' />
                        </span> */}
                          <span
                            className='cursor-p'
                            onClick={() =>
                              dispatch(deleteClause(item?.clause_id))
                            }
                          >
                            <MdClear className='text-danger' />
                          </span>
                        </div>
                        {provided.placeholder}
                      </div>
                    )}
                  </Draggable>
                ))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className='d-flex gap-2 justify-content-end my-2'>
          <button
            className='btn btn-sm btn-secondary d-flex gap-1 align-items-center'
            onClick={() => ref.current.click()}
          >
            <BiArrowBack />
            <span>Previous</span>
          </button>
          <button
            type='button'
            className='btn btn-sm btn-primary text-center'
            data-bs-toggle='modal'
            data-bs-target='#confirm_underwrite'
            disabled={isLoading}
          >
            Submit
          </button>
        </div>
        <AddPreloadedClause
          modal_id='add_clause'
          data={preloadedClauses}
          editData={editData}
          setEditData={setEditData}
        />
        <ModalContainer
          modal_id='confirm_underwrite'
          modal_width='modal-sm'
          bradius='rounded-2'
        >
          <ConfirmUnderwrite
            handleSubmit={handleSubmit}
            prompt='By clicking OK you agree that all details are correct.'
          />
        </ModalContainer>
      </div>
    );
  }
);

export default PreloadedClauses;
